<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <!-- <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on">
        <v-icon left> mdi-calendar </v-icon>
        Schedule An Appointment
      </v-btn>
    </template> -->
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Schedule An Appointment</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false"> Save </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <Dashboard />
    </v-card>
  </v-dialog>
</template>

<script>
import Dashboard from '@/views/Dashboard'

export default {
  data () {
    return {
      dialog: false
    }
  },
  components: {
    Dashboard
  }
}
</script>
